import './FolderButton.3782aae483f3a78152c7794423b7c52b.css';
export default {"folderButton":"_folderButton_1k4m0_1","text":"_text_1k4m0_1"};